import { ENDPOINTS } from 'config/endpoints';
import client from 'utils/clients/client';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { List } from 'crono-fe-common/types/list';

export default function useGetList(listId?: number | null, enabled = true) {
  // Lists have positive ids; the lists context uses -1 for "no list".
  const hasList = !!listId && listId > 0;
  const query = new URLSearchParams();
  if (hasList) {
    query.append('listId', listId.toString());
  }
  const searchLists = async () => {
    const request: Request = {
      url: `${ENDPOINTS.list.main}?${query.toString()}`,
      config: {
        method: 'GET',
      },
    };

    return client(request);
  };

  const { data, ...rest } = useQuery<Response<List | null>, CronoError>(
    [ENDPOINTS.list.main, listId],
    searchLists,
    {
      staleTime: 5 * 60 * 1000,
      enabled: hasList && enabled,
    },
  );

  return { data, ...rest };
}
